<af-full-table class="w-100 h-100"
               [showFilter]="false"
               [showPaginator]="false"
               [showImport]="false"
               [showExport]="false"
               [dataSource]="dataSource"
               [sortEvent]="sortedBy"
               [columnTranslationPrefixes]="{status: 'contactDetails'}"
               additionalSpinnerIds="contactDetails"
               emptyStateIconName="ic_empty_state_no_contacts"
               emptyStateTitleTranslationKey="i18n_af_emptyStateTitleContactsNotAdded"
               emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleContactsNotAdded"
               (tableUpdateListener)="onTableUpdate($event)"/>
